// react-pinterest-tag is a UMD bundle that dereferences `window` at module scope,
// so a static import anywhere in the marketing SSR graph (firebase.ts is imported by
// several marketing feature pages) crashes the entire entry-server.mjs bundle on
// import in Node. Lazy-load it on first use instead; init/pageView stay in App.tsx,
// which is never server-rendered.
export const trackPinterest = (event: string, data?: Record<string, unknown>) => {
	if (typeof window === "undefined") return;
	import("react-pinterest-tag")
		.then(({ default: ReactPinterestTag }) => ReactPinterestTag.track(event, data))
		.catch(() => {
			// Tracker blocked or failed to load — never break the signup flow over analytics
		});
};
